const discountTypeLookup = {
    "VALUE_BASED": 1,
    "PERCENT_BASED": 2
}

export { discountTypeLookup };